// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-diagram-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 200px);
  min-height: 500px;
  overflow: hidden;
  background: #fafbfc;
  border: 1px solid var(--light-grey);
  border-radius: 4px;
}

.workflow-diagram-container svg {
  width: 100%;
  height: 100%;
  cursor: grab;
}

.workflow-diagram-container svg:active {
  cursor: grabbing;
}

/* --- Controls panel --- */
.workflow-diagram-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  gap: 8px;
  align-items: center;
}

.workflow-diagram-btn {
  padding: 4px 10px;
  font-size: 12px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.9;
}

.workflow-diagram-btn:hover {
  opacity: 1;
  border-color: #999;
  background: #f8f9fa;
}

.workflow-diagram-btn-active {
  background: #e7f1ff;
  border-color: #0056b3;
  color: #0056b3;
}

.workflow-diagram-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
  padding: 4px 8px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  opacity: 0.9;
}

.workflow-diagram-toggle:hover {
  opacity: 1;
  border-color: #999;
}

.workflow-diagram-toggle input {
  margin: 0;
  cursor: pointer;
}

.workflow-diagram-select {
  padding: 4px 8px;
  font-size: 12px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  color: #555;
  max-width: 180px;
}

.workflow-diagram-select:hover {
  border-color: #999;
}

.workflow-diagram-select:focus {
  outline: none;
  border-color: #0056b3;
}

.workflow-diagram-process-dropdown {
  font-size: 11px;
  padding: 3px 6px;
  width: 210px;
  max-width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
}

.workflow-diagram-hint {
  position: absolute;
  top: 48px;
  right: 10px;
  z-index: 10;
  padding: 3px 8px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #555;
  font-size: 12px;
  line-height: 1.3;
  pointer-events: none;
}

/* --- Legend --- */
.workflow-legend {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  font-size: 13px;
  color: #555;
}

.workflow-legend.collapsed {
  padding: 6px 10px;
}

.workflow-legend.expanded {
  padding: 10px 14px;
  min-width: 430px;
}

.workflow-legend-title {
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  padding-bottom: 6px;
}

.workflow-legend-title:hover {
  color: #0056b3;
}

.workflow-legend-toggle {
  font-size: 10px;
  color: #666;
}

.workflow-legend-content {
  margin-top: 6px;
  border-top: 1px solid #eee;
  padding-top: 5px;
}

.workflow-legend-row {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 6px;
  white-space: nowrap;
}

.workflow-legend-row:first-child {
  margin-top: 0;
}

.workflow-legend-label {
  font-weight: 600;
  color: #444;
  width: 78px;
  flex-shrink: 0;
}

.workflow-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.workflow-legend-edge {
  width: 32px;
  height: 0;
  border-top: 2px solid #3b82c4;
  position: relative;
}

.workflow-legend-edge::after {
  content: "";
  position: absolute;
  right: -1px;
  top: -4px;
  border-left: 6px solid #3b82c4;
  border-top: 3px solid transparent;
  border-bottom: 3px solid transparent;
}

.workflow-legend-edge.cross {
  border-top-style: dashed;
  border-color: #d6a02f;
}

.workflow-legend-edge.cross::after {
  border-left-color: #d6a02f;
}

.workflow-legend-edge.bidirectional {
  border-color: #8e62b8;
}

.workflow-legend-edge.bidirectional::before {
  content: "";
  position: absolute;
  left: -1px;
  top: -4px;
  border-right: 6px solid #8e62b8;
  border-top: 3px solid transparent;
  border-bottom: 3px solid transparent;
}

.workflow-legend-edge.bidirectional::after {
  border-left-color: #8e62b8;
}


/* --- Group bounding boxes --- */
.wf-group rect.wf-group-bg {
  rx: 8;
  ry: 8;
  stroke-width: 1.5;
  stroke-dasharray: 6 3;
}

.wf-group rect.wf-group-header {
  rx: 8;
  ry: 8;
  cursor: pointer;
}

.wf-group text.wf-group-label {
  font-size: 13px;
  font-weight: 600;
  fill: #333;
  pointer-events: none;
}

.wf-group text.wf-group-toggle {
  font-size: 11px;
  fill: #666;
  pointer-events: none;
}

/* --- Normal nodes --- */
.wf-node rect {
  rx: 6;
  ry: 6;
  fill: white;
  stroke: #5a9bd5;
  stroke-width: 1.5;
  cursor: grab;
  transition: filter 0.15s;
}

.wf-node rect:hover {
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.15));
  stroke-width: 2;
}

.wf-node.wf-dragging rect {
  cursor: grabbing;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));
  stroke-width: 2.5;
}

.wf-node text {
  font-size: 12px;
  fill: #333;
  pointer-events: none;
}


/* --- Summary (collapsed) nodes --- */
.wf-summary-node rect {
  rx: 10;
  ry: 10;
  fill: #eef3f8;
  stroke: #3a7cbd;
  stroke-width: 2;
  cursor: grab;
  transition: filter 0.15s;
}

.wf-summary-node.wf-dragging rect {
  cursor: grabbing;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));
  stroke-width: 2.5;
}

/* --- Sub-summary (collapsed subprocess) nodes --- */
.wf-subsummary-node rect {
  rx: 8;
  ry: 8;
  fill: #f5f8fc;
  stroke: #7bafd4;
  stroke-width: 1.5;
  cursor: grab;
  transition: filter 0.15s;
}

.wf-subsummary-node rect:hover {
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.15));
  stroke-width: 2;
}

.wf-subsummary-node.wf-dragging rect {
  cursor: grabbing;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));
}

.wf-subsummary-node text.wf-summary-label {
  font-size: 12px;
  font-weight: 600;
  fill: #3a6a8a;
  pointer-events: none;
}

.wf-subsummary-node text.wf-summary-count {
  font-size: 10px;
  fill: #6a9ab5;
  pointer-events: none;
}

/* --- Subprocess group boxes --- */
.wf-subgroup rect.wf-subgroup-bg {
  rx: 6;
  ry: 6;
  stroke-width: 1;
  stroke-dasharray: 4 2;
}

.wf-subgroup rect.wf-subgroup-header {
  rx: 6;
  ry: 6;
  cursor: pointer;
}

.wf-subgroup text.wf-subgroup-label {
  font-size: 12px;
  font-weight: 600;
  fill: #444;
  pointer-events: none;
}

.wf-subgroup text.wf-subgroup-toggle {
  font-size: 10px;
  fill: #666;
  pointer-events: none;
}

.wf-summary-node rect:hover {
  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.2));
  stroke-width: 2.5;
}

.wf-summary-node text.wf-summary-label {
  font-size: 13px;
  font-weight: 600;
  fill: #2a5f8f;
  pointer-events: none;
}

.wf-summary-node text.wf-summary-count {
  font-size: 11px;
  fill: #5a8ab5;
  pointer-events: none;
}

/* --- Edges --- */
.wf-edge path {
  fill: none;
  stroke: #5a9bd5;  /* Default blue stroke */
  stroke-width: 1.5;
  cursor: pointer;
  transition: stroke 0.15s, stroke-width 0.15s;
}

.wf-edge path:hover {
  stroke-width: 2.5;
}

.wf-edge.wf-edge-primary path {
  opacity: 1;
}

.wf-edge.wf-edge-special path {
  opacity: 0.48;
}

.wf-edge.wf-edge-selected path {
  opacity: 1;
}

.wf-edge.wf-edge-special path:hover {
  opacity: 0.9;
}

/* Internal edges (within same process group) */
.wf-edge.wf-edge-internal path {
  stroke: #5a9bd5;
}

.wf-edge.wf-edge-internal path:hover {
  stroke: #3a7cbd;
}

/* External edges (cross process groups) */
.wf-edge.wf-edge-external path {
  stroke: #d4a03c;
  stroke-dasharray: 6 3;
}

.wf-edge.wf-edge-external path:hover {
  stroke: #b8862a;
}

/* Bidirectional edges */
.wf-edge.wf-bidirectional path {
  stroke: #9b6fbd;
}

.wf-edge.wf-bidirectional path:hover {
  stroke: #7a4fa0;
}


/* Side-state / exception transitions. These are hidden in Simple View,
   and appear in Focused View or Full View with a softer visual weight. */
.wf-edge.wf-edge-side path {
  stroke-width: 1.35;
  opacity: 0.45;
}

.wf-edge.wf-edge-side.wf-edge-selected path {
  opacity: 1;
  stroke-width: 2.25;
}

.wf-edge.wf-edge-side path:hover {
  opacity: 0.95;
}

/* --- Loading / error states --- */
.workflow-diagram-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  gap: 10px;
  color: #666;
}

.workflow-diagram-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: var(--medium-red);
}

/* --- Tooltip (positioned div) --- */
.wf-tooltip {
  position: absolute;
  z-index: 100;
  max-width: 380px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  pointer-events: none;
  font-size: 13px;
}

.wf-tooltip-header {
  font-size: 13px;
  font-weight: 600;
  background: #f0f5fa;
  padding: 6px 12px;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 6px 6px 0 0;
}

.wf-tooltip-body {
  padding: 8px 12px;
}

.wf-popover-atp {
  font-family: monospace;
  font-size: 11px;
  color: #666;
  margin-bottom: 4px;
}

.wf-popover-process {
  font-size: 12px;
  color: #555;
  margin-bottom: 8px;
}

.wf-popover-hint {
  font-size: 12px;
  color: #555;
  margin-bottom: 8px;
}

.wf-popover-section-title {
  font-weight: 600;
  font-size: 12px;
  margin-top: 6px;
  margin-bottom: 2px;
  color: #444;
}

.wf-popover-transition {
  font-size: 12px;
  padding: 2px 0;
  border-bottom: 1px solid #f0f0f0;
}

.wf-popover-transition:last-child {
  border-bottom: none;
}

.wf-popover-detail {
  font-size: 11px;
  color: #666;
  margin-left: 8px;
}

.wf-popover-arrow {
  font-size: 11px;
  color: #999;
  margin: 0 4px;
}
/* Full view is intended for debugging. Keep exception/status transitions very quiet
   so the main workflow remains readable even when all transitions are visible. */
.wf-edge.wf-edge-full-view.wf-edge-side path {
  opacity: 0.16;
  stroke-width: 1;
}

.wf-edge.wf-edge-full-view.wf-edge-special:not(.wf-edge-side) path {
  opacity: 0.28;
}

.wf-edge.wf-edge-full-view.wf-edge-side path:hover,
.wf-edge.wf-edge-full-view.wf-edge-special path:hover {
  opacity: 0.85;
  stroke-width: 1.75;
}


/* --- Roll-up workflow labeling --- */
.wf-group text.wf-group-badge {
  font-size: 10px;
  font-weight: 600;
  fill: #795800;
  pointer-events: none;
}

.wf-group text.wf-group-helper {
  font-size: 10px;
  fill: #555;
  pointer-events: none;
}

.wf-summary-node text.wf-summary-count {
  text-transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkflowDiagram.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA,iCAAiC;AACjC;EACE,KAAK;EACL,KAAK;EACL,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,KAAK;EACL,KAAK;EACL,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,KAAK;EACL,KAAK;EACL,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;;AAGA,sCAAsC;AACtC;EACE,MAAM;EACN,MAAM;EACN,aAAa;EACb,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;EACE,KAAK;EACL,KAAK;EACL,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,KAAK;EACL,KAAK;EACL,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,KAAK;EACL,KAAK;EACL,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,eAAe,GAAG,wBAAwB;EAC1C,iBAAiB;EACjB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;;AAGA;yEACyE;AACzE;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;AACA;iFACiF;AACjF;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;;AAGA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".workflow-diagram-container {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 200px);\n  min-height: 500px;\n  overflow: hidden;\n  background: #fafbfc;\n  border: 1px solid var(--light-grey);\n  border-radius: 4px;\n}\n\n.workflow-diagram-container svg {\n  width: 100%;\n  height: 100%;\n  cursor: grab;\n}\n\n.workflow-diagram-container svg:active {\n  cursor: grabbing;\n}\n\n/* --- Controls panel --- */\n.workflow-diagram-controls {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.workflow-diagram-btn {\n  padding: 4px 10px;\n  font-size: 12px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.workflow-diagram-btn:hover {\n  opacity: 1;\n  border-color: #999;\n  background: #f8f9fa;\n}\n\n.workflow-diagram-btn-active {\n  background: #e7f1ff;\n  border-color: #0056b3;\n  color: #0056b3;\n}\n\n.workflow-diagram-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n  padding: 4px 8px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  opacity: 0.9;\n}\n\n.workflow-diagram-toggle:hover {\n  opacity: 1;\n  border-color: #999;\n}\n\n.workflow-diagram-toggle input {\n  margin: 0;\n  cursor: pointer;\n}\n\n.workflow-diagram-select {\n  padding: 4px 8px;\n  font-size: 12px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #555;\n  max-width: 180px;\n}\n\n.workflow-diagram-select:hover {\n  border-color: #999;\n}\n\n.workflow-diagram-select:focus {\n  outline: none;\n  border-color: #0056b3;\n}\n\n.workflow-diagram-process-dropdown {\n  font-size: 11px;\n  padding: 3px 6px;\n  width: 210px;\n  max-width: 210px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  pointer-events: auto;\n}\n\n.workflow-diagram-hint {\n  position: absolute;\n  top: 48px;\n  right: 10px;\n  z-index: 10;\n  padding: 3px 8px;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  color: #555;\n  font-size: 12px;\n  line-height: 1.3;\n  pointer-events: none;\n}\n\n/* --- Legend --- */\n.workflow-legend {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 10;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n  font-size: 13px;\n  color: #555;\n}\n\n.workflow-legend.collapsed {\n  padding: 6px 10px;\n}\n\n.workflow-legend.expanded {\n  padding: 10px 14px;\n  min-width: 430px;\n}\n\n.workflow-legend-title {\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n  padding-bottom: 6px;\n}\n\n.workflow-legend-title:hover {\n  color: #0056b3;\n}\n\n.workflow-legend-toggle {\n  font-size: 10px;\n  color: #666;\n}\n\n.workflow-legend-content {\n  margin-top: 6px;\n  border-top: 1px solid #eee;\n  padding-top: 5px;\n}\n\n.workflow-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-top: 6px;\n  white-space: nowrap;\n}\n\n.workflow-legend-row:first-child {\n  margin-top: 0;\n}\n\n.workflow-legend-label {\n  font-weight: 600;\n  color: #444;\n  width: 78px;\n  flex-shrink: 0;\n}\n\n.workflow-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.workflow-legend-edge {\n  width: 32px;\n  height: 0;\n  border-top: 2px solid #3b82c4;\n  position: relative;\n}\n\n.workflow-legend-edge::after {\n  content: \"\";\n  position: absolute;\n  right: -1px;\n  top: -4px;\n  border-left: 6px solid #3b82c4;\n  border-top: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n\n.workflow-legend-edge.cross {\n  border-top-style: dashed;\n  border-color: #d6a02f;\n}\n\n.workflow-legend-edge.cross::after {\n  border-left-color: #d6a02f;\n}\n\n.workflow-legend-edge.bidirectional {\n  border-color: #8e62b8;\n}\n\n.workflow-legend-edge.bidirectional::before {\n  content: \"\";\n  position: absolute;\n  left: -1px;\n  top: -4px;\n  border-right: 6px solid #8e62b8;\n  border-top: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n\n.workflow-legend-edge.bidirectional::after {\n  border-left-color: #8e62b8;\n}\n\n\n/* --- Group bounding boxes --- */\n.wf-group rect.wf-group-bg {\n  rx: 8;\n  ry: 8;\n  stroke-width: 1.5;\n  stroke-dasharray: 6 3;\n}\n\n.wf-group rect.wf-group-header {\n  rx: 8;\n  ry: 8;\n  cursor: pointer;\n}\n\n.wf-group text.wf-group-label {\n  font-size: 13px;\n  font-weight: 600;\n  fill: #333;\n  pointer-events: none;\n}\n\n.wf-group text.wf-group-toggle {\n  font-size: 11px;\n  fill: #666;\n  pointer-events: none;\n}\n\n/* --- Normal nodes --- */\n.wf-node rect {\n  rx: 6;\n  ry: 6;\n  fill: white;\n  stroke: #5a9bd5;\n  stroke-width: 1.5;\n  cursor: grab;\n  transition: filter 0.15s;\n}\n\n.wf-node rect:hover {\n  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.15));\n  stroke-width: 2;\n}\n\n.wf-node.wf-dragging rect {\n  cursor: grabbing;\n  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));\n  stroke-width: 2.5;\n}\n\n.wf-node text {\n  font-size: 12px;\n  fill: #333;\n  pointer-events: none;\n}\n\n\n/* --- Summary (collapsed) nodes --- */\n.wf-summary-node rect {\n  rx: 10;\n  ry: 10;\n  fill: #eef3f8;\n  stroke: #3a7cbd;\n  stroke-width: 2;\n  cursor: grab;\n  transition: filter 0.15s;\n}\n\n.wf-summary-node.wf-dragging rect {\n  cursor: grabbing;\n  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));\n  stroke-width: 2.5;\n}\n\n/* --- Sub-summary (collapsed subprocess) nodes --- */\n.wf-subsummary-node rect {\n  rx: 8;\n  ry: 8;\n  fill: #f5f8fc;\n  stroke: #7bafd4;\n  stroke-width: 1.5;\n  cursor: grab;\n  transition: filter 0.15s;\n}\n\n.wf-subsummary-node rect:hover {\n  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.15));\n  stroke-width: 2;\n}\n\n.wf-subsummary-node.wf-dragging rect {\n  cursor: grabbing;\n  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));\n}\n\n.wf-subsummary-node text.wf-summary-label {\n  font-size: 12px;\n  font-weight: 600;\n  fill: #3a6a8a;\n  pointer-events: none;\n}\n\n.wf-subsummary-node text.wf-summary-count {\n  font-size: 10px;\n  fill: #6a9ab5;\n  pointer-events: none;\n}\n\n/* --- Subprocess group boxes --- */\n.wf-subgroup rect.wf-subgroup-bg {\n  rx: 6;\n  ry: 6;\n  stroke-width: 1;\n  stroke-dasharray: 4 2;\n}\n\n.wf-subgroup rect.wf-subgroup-header {\n  rx: 6;\n  ry: 6;\n  cursor: pointer;\n}\n\n.wf-subgroup text.wf-subgroup-label {\n  font-size: 12px;\n  font-weight: 600;\n  fill: #444;\n  pointer-events: none;\n}\n\n.wf-subgroup text.wf-subgroup-toggle {\n  font-size: 10px;\n  fill: #666;\n  pointer-events: none;\n}\n\n.wf-summary-node rect:hover {\n  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.2));\n  stroke-width: 2.5;\n}\n\n.wf-summary-node text.wf-summary-label {\n  font-size: 13px;\n  font-weight: 600;\n  fill: #2a5f8f;\n  pointer-events: none;\n}\n\n.wf-summary-node text.wf-summary-count {\n  font-size: 11px;\n  fill: #5a8ab5;\n  pointer-events: none;\n}\n\n/* --- Edges --- */\n.wf-edge path {\n  fill: none;\n  stroke: #5a9bd5;  /* Default blue stroke */\n  stroke-width: 1.5;\n  cursor: pointer;\n  transition: stroke 0.15s, stroke-width 0.15s;\n}\n\n.wf-edge path:hover {\n  stroke-width: 2.5;\n}\n\n.wf-edge.wf-edge-primary path {\n  opacity: 1;\n}\n\n.wf-edge.wf-edge-special path {\n  opacity: 0.48;\n}\n\n.wf-edge.wf-edge-selected path {\n  opacity: 1;\n}\n\n.wf-edge.wf-edge-special path:hover {\n  opacity: 0.9;\n}\n\n/* Internal edges (within same process group) */\n.wf-edge.wf-edge-internal path {\n  stroke: #5a9bd5;\n}\n\n.wf-edge.wf-edge-internal path:hover {\n  stroke: #3a7cbd;\n}\n\n/* External edges (cross process groups) */\n.wf-edge.wf-edge-external path {\n  stroke: #d4a03c;\n  stroke-dasharray: 6 3;\n}\n\n.wf-edge.wf-edge-external path:hover {\n  stroke: #b8862a;\n}\n\n/* Bidirectional edges */\n.wf-edge.wf-bidirectional path {\n  stroke: #9b6fbd;\n}\n\n.wf-edge.wf-bidirectional path:hover {\n  stroke: #7a4fa0;\n}\n\n\n/* Side-state / exception transitions. These are hidden in Simple View,\n   and appear in Focused View or Full View with a softer visual weight. */\n.wf-edge.wf-edge-side path {\n  stroke-width: 1.35;\n  opacity: 0.45;\n}\n\n.wf-edge.wf-edge-side.wf-edge-selected path {\n  opacity: 1;\n  stroke-width: 2.25;\n}\n\n.wf-edge.wf-edge-side path:hover {\n  opacity: 0.95;\n}\n\n/* --- Loading / error states --- */\n.workflow-diagram-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  gap: 10px;\n  color: #666;\n}\n\n.workflow-diagram-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  color: var(--medium-red);\n}\n\n/* --- Tooltip (positioned div) --- */\n.wf-tooltip {\n  position: absolute;\n  z-index: 100;\n  max-width: 380px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  pointer-events: none;\n  font-size: 13px;\n}\n\n.wf-tooltip-header {\n  font-size: 13px;\n  font-weight: 600;\n  background: #f0f5fa;\n  padding: 6px 12px;\n  border-bottom: 1px solid #e0e0e0;\n  border-radius: 6px 6px 0 0;\n}\n\n.wf-tooltip-body {\n  padding: 8px 12px;\n}\n\n.wf-popover-atp {\n  font-family: monospace;\n  font-size: 11px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.wf-popover-process {\n  font-size: 12px;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.wf-popover-hint {\n  font-size: 12px;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.wf-popover-section-title {\n  font-weight: 600;\n  font-size: 12px;\n  margin-top: 6px;\n  margin-bottom: 2px;\n  color: #444;\n}\n\n.wf-popover-transition {\n  font-size: 12px;\n  padding: 2px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.wf-popover-transition:last-child {\n  border-bottom: none;\n}\n\n.wf-popover-detail {\n  font-size: 11px;\n  color: #666;\n  margin-left: 8px;\n}\n\n.wf-popover-arrow {\n  font-size: 11px;\n  color: #999;\n  margin: 0 4px;\n}\n/* Full view is intended for debugging. Keep exception/status transitions very quiet\n   so the main workflow remains readable even when all transitions are visible. */\n.wf-edge.wf-edge-full-view.wf-edge-side path {\n  opacity: 0.16;\n  stroke-width: 1;\n}\n\n.wf-edge.wf-edge-full-view.wf-edge-special:not(.wf-edge-side) path {\n  opacity: 0.28;\n}\n\n.wf-edge.wf-edge-full-view.wf-edge-side path:hover,\n.wf-edge.wf-edge-full-view.wf-edge-special path:hover {\n  opacity: 0.85;\n  stroke-width: 1.75;\n}\n\n\n/* --- Roll-up workflow labeling --- */\n.wf-group text.wf-group-badge {\n  font-size: 10px;\n  font-weight: 600;\n  fill: #795800;\n  pointer-events: none;\n}\n\n.wf-group text.wf-group-helper {\n  font-size: 10px;\n  fill: #555;\n  pointer-events: none;\n}\n\n.wf-summary-node text.wf-summary-count {\n  text-transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
